import styled, {keyframes} from 'styled-components';

const rotate = keyframes`
    0% {
      background-position: 100% 0%;
    }
    100% {
      background-position: 0% 0%;
    }    
`;

const color1 = 'rgba(0,0,0,0)';
const color2 = 'rgba(0,0,0,.1)';

export const GradientAnimation = styled.div`
  height: 100%;
  width: 100%;

  background: linear-gradient(95deg, ${color1} 0%, ${color1} 25%, ${color2} 50%, ${color1} 75%);
  background-size: 400% 100%;
  animation: ${rotate} 4s infinite;

  min-height: 100px;
`;
